
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const AdminRoute: React.FC = () => {
  const isAdmin = !!localStorage.getItem('admin_token');

  return isAdmin ? <Outlet /> : <Navigate to="/adminlogin" />;
};

export default AdminRoute;
